import React, { Component } from 'react';
import {
  Navbar,
  Row,
  Col,
} from 'react-bootstrap';
// icons
import IconBuilding from 'react-icons/lib/fa/building-o';
import IconLogs from 'react-icons/lib/fa/list';
import IconSettings from 'react-icons/lib/fa/cog';
import IconSignOut from 'react-icons/lib/fa/sign-out';
// app history
import appHistory from '../../history';
// components
import Logo from '../../brand/Logo';
// stores
import UserStore from '../../stores/UserStore';

import './Nav.css';

const NavItems = [
  {
    Icon: IconBuilding,
    text: "Home",
    onClick: () => appHistory.push("properties"),
  },
  {
    Icon: IconLogs,
    text: "Logs",
    onClick: () => appHistory.push("logs"),
  },
  {
    Icon: IconSettings,
    text: "Settings",
    onClick: () => appHistory.push("settings"),
  },
  {
    Icon: IconSignOut,
    text: "Sign out",
    onClick: () => {
      appHistory.push("/auth");
      UserStore.logout();
    },
  },
];

class TopNav extends Component {
  render() {
    return (
      <Navbar inverse fluid className="TopNav-container">
        <Row style={{ minHeight: "50px", lineHeight: "50px"}}>
          <Col xs={3}><Logo /></Col>
          <Col xs={9} style={{textAlign: "right"}}>
            {NavItems.map(this.renderNavItem)}
          </Col>
        </Row>
      </Navbar>
    );
  }

  // not sure why, but Icon needs to be capitalized
  renderNavItem = ({Icon, text, onClick}, index) => {
    return (
      <div key={index} className="TopNav-navitem-container" onClick={onClick}>
        <span className="TopNav-navitem-icon"><Icon /></span>
        <span className="TopNav-navitem-text hidden-xs">{text}</span>
      </div>
    );
  }
}

export default TopNav;


// WEBPACK FOOTER //
// ./src/pages/Nav/TopNav.js